import { put, takeLatest, select, call } from "redux-saga/effects";
import * as types from "./types";
import * as actions from "./actions";
import { isNumericValue } from "../../utils/Helpers";
import { getEventRequestRequest } from "../Requests/actions";

function* fetchPersistRequestSaga(action) {
  const { id } = action.payload;
  const {
    page,
    rowsCount,
    searchValue,
    filterRequestStatus,
    filterRating,
    filterGender,
    filterRole,
    filterCity,
    filterLanguage,
    filterNationality,
    filterSpeaking,
    filterShift,
  } = yield select((state) => state.joiningRequest);
  const searchParams = isNumericValue(searchValue)
    ? { user_id: searchValue }
    : { event_and_user_name: searchValue };
  yield put(
    getEventRequestRequest({
      id,
      params: {
        page,
        items: rowsCount,
        ...searchParams,
        status: filterRequestStatus?.value,
        role_id: filterRole?.id,
        gender: filterGender?.value,
        order_by_created_at: "asc",
        responseType: "requests",
        min_user_rating: filterRating?.value,
        max_user_rating: filterRating?.value
          ? filterRating?.value + 0.99
          : null,
        city_id: filterCity?.id,
        nationality_id: filterNationality?.id,
        language_id: filterLanguage?.id,
        speaking_proficiency: filterSpeaking?.value,
        event_role_shift_id: filterShift?.id,
      },
    })
  );
}

function* loadInitialRequestSaga(action) {
  try {
    yield call(fetchPersistRequestSaga, action);
  } catch (error) {
    console.log(error);
  }
}

function* pageRequestSaga(action) {
  try {
    const { page } = yield select((state) => state.joiningRequest);
    if (action.payload !== page) {
      yield put(actions.setPageRequest(action.payload));
    }
  } catch (error) {
    console.log(error);
  }
}

function* filtersRequestSaga(action) {
  try {
    const currentFilters = yield select((state) => state.joiningRequest);
    const newFilters = action.payload;
    if (JSON.stringify(currentFilters) !== JSON.stringify(newFilters)) {
      yield put(actions.setFiltersRequest(newFilters));
    }
  } catch (error) {
    console.log(error);
  }
}

function* rowsCountRequestSaga(action) {
  try {
    const { rowsCount } = yield select((state) => state.joiningRequest);
    if (action.payload !== rowsCount) {
      yield put(actions.setRowsCountRequest(action.payload));
    }
  } catch (error) {
    console.log(error);
  }
}

function* selectedApplicantRequestSaga(action) {
  try {
    const { selectedApplicantRequestIds } = yield select(
      (state) => state.joiningRequest
    );
    const newSelection = action.payload;
    const selectionChanged =
      newSelection.length !== selectedApplicantRequestIds.length ||
      !newSelection.every((id) => selectedApplicantRequestIds.includes(id));
    if (selectionChanged) {
      yield put(actions.setApplicantRequestIds(newSelection));
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* joiningRequest() {
  yield takeLatest(types.SET_PAGE_REQUEST, pageRequestSaga);
  yield takeLatest(types.SET_FILTERS_REQUEST, filtersRequestSaga);
  yield takeLatest(types.SET_ROWS_COUNT_REQUEST, rowsCountRequestSaga);
  yield takeLatest(types.INITIAL_FETCH_REQUEST, loadInitialRequestSaga);
  yield takeLatest(types.SET_SELECTED_REQUEST_ID, selectedApplicantRequestSaga);
}
